import { Link } from "gatsby"
import React, { useEffect, useState, useRef } from "react"
import ScrollAnimation from "react-animate-on-scroll"
import {
  Button,
  Navbar,
  Nav,
  Form,
  Container,
  FormControl,
  Row,
  Col,
  dark,
} from "react-bootstrap"
import "./AreaGuides.scss"
import "react-multi-carousel/lib/styles.css"
import ReportImg from "../../../images/property-report.jpg"
import PlayVideo from "../../Play/PlayVideo"
import getVideoId from "get-video-id"
const BuyersReportVideo = props => {
  // window.scrollTo(0, 0);
  const [isPlay, setPlay] = useState(false)
  const [isPlaying, setPlaying] = useState(false)
  const videoClick = value => {
    props.handleClick(value)
  }
  const videoid =
    props.VideoURL &&
    props.VideoURL[0] &&
    getVideoId(props.VideoURL[0].Youtube_Video_URL)

  const reportImg = props.FormBanner && props.FormBanner[0]?.Banner_Image?.url

  return (
    <React.Fragment>
      <section className={`area-guides pt-0 report-page-video ${props.type}`}>
        <div className="area-guide-video-carousel">
          <div className="item">
            <div className="video-img-box">
              <div className={`buyers-report-image ${props.type}`}>
                <picture>
                  {reportImg && (
                    <img
                      src={reportImg}
                      alt="Buyers Report - Location Location"
                    />
                  )}
                </picture>
                <a
                  to="#"
                  className="video-arrow"
                  onClick={e => {
                    setPlay(true)
                    videoClick("video-open")
                  }}
                >
                  <i class="icon-video-white"></i>
                </a>
                <p>
                  <span>
                    What is the{" "}
                    {props.type === "sales"
                      ? "Buyers Report"
                      : "Residents Report"}
                    ?
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {videoid && (
        <PlayVideo
          isOpen={isPlay}
          isCloseFunction={e => {
            setPlay()
            videoClick("")
          }}
          videoId={
            props.VideoURL &&
            props.VideoURL[0] &&
            props.VideoURL[0].Youtube_Video_URL
          }
          isAutoPlay={1}
        />
      )}
    </React.Fragment>
  )
}

export default BuyersReportVideo
